<template>
  <div class="page">
    <div class="page__bd" style="height: 100%">
      <div class="weui-tab" style="color: white">
        <div class="weui-navbar">
          <div
            role="tab"
            aria-selected="true"
            aria-controls="panel1"
            id="tab1"
            class="weui-navbar__item"
            :class="{ 'weui-bar__item_on': activePage=='windows' }"
            @click="
              activePage='windows'
            "
          >
            Windows
          </div>
          <div
            role="tab"
            aria-selected="true"
            aria-controls="panel2"
            id="tab2"
            class="weui-navbar__item"
            :class="{ 'weui-bar__item_on': activePage=='mac' }"
            @click="
              activePage='mac'
            "
          >
            Mac
          </div>
          <div
            role="tab"
            aria-selected="true"
            aria-controls="panel3"
            id="tab3"
            class="weui-navbar__item"
            :class="{ 'weui-bar__item_on': activePage=='linux' }"
            @click="
              activePage='linux'
            "
          >
            Linux
          </div>
          <div
            role=" tab"
            aria-selected="true"
            aria-controls="panel3"
            id="tab4"
            class="weui-navbar__item"
            :class="{ 'weui-bar__item_on': activePage=='android' }"
            @click="
              activePage='android'
            "
          >
            Android
          </div>
        </div>
        <div
          v-if="activePage=='windows'"
          role="tabpanel"
          id="panel1"
          aria-labelledby="tab1"
          class="weui-tab__panel"
          style="padding: 0.5rem"
        >
          <div class="weui-form__desc" style="text-align: center">
            <p>{{ $t("inst.windowsDesc") }}</p>
          </div>

          <div
            class="weui-form__opr-area"
            style="padding-top: 32px; margin-bottom: 32px"
          >
            <a class="weui-btn weui-btn_primary" :href="windows64setup"
              >Windows 64{{ $t("bit") }}</a
            >
          </div>
          <div style="padding-bottom: 1rem">
            <a class="weui-btn weui-btn_primary" :href="windows32setup"
              >Windows 32{{ $t("bit") }}</a
            >
          </div>
          {{ $t("inst.win10warn") }}
          <div v-if="locale == 'zh-cn'">
            <img
              style="max-width: 100%; height: auto; overflow: hidden"
              src="../../static/images/win10warn.png"
            />
            <img
              style="max-width: 100%; height: auto; overflow: hidden"
              src="../../static/images/stillrun.png"
            />
          </div>

          <div v-if="locale === 'en-us'">
            <img
              style="max-width: 100%; height: auto; overflow: hidden"
              src="../../static/images/win10warn_en.png"
            />
            <img
              style="max-width: 100%; height: auto; overflow: hidden"
              src="../../static/images/stillrun_en.png"
            />
          </div>
        </div>
        <div v-if="activePage=='mac'" role="tabpanel" class="weui-tab__panel">
          <div style="padding-top: 24px; padding-bottom: 24px">
            {{ $t("inst.linuxDesc") }}
          </div>
          <div class="weui-cell weui-cell_swiped">
            <div
              role="option"
              class="weui-cell__bd"
              style="transform: translateX(-68px)"
            >
              <div class="weui-cell">
                <textarea
                  id="installcmd"
                  v-model="installcmd"
                  class="weui-textarea"
                  style="padding-left: 64px"
                />
              </div>
            </div>
            <div class="weui-cell__ft">
              <a
                role="button"
                class="copy weui-swiped-btn weui-btn_primary"
                :data-clipboard-text="installcmd"
                @click="toClipboard"
                >{{ $t("copy") }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="activePage=='linux'" role="tabpanel" class="weui-tab__panel">
          <div class="weui-form__desc" style="text-align: center">
            <p>{{ $t("inst.linuxDesc") }}</p>
          </div>
          <div style="padding-top: 24px; padding-bottom: 24px">
            {{ $t("inst.linuxDescSh") }}
          </div>
          <div class="weui-cell weui-cell_swiped">
            <div
              role="option"
              class="weui-cell__bd"
              style="transform: translateX(-68px)"
            >
              <div class="weui-cell">
                <textarea
                  v-model="installcmd"
                  class="weui-textarea"
                  style="padding-left: 64px; min-height: 100px"
                />
              </div>
            </div>
            <div class="weui-cell__ft">
              <a
                role="button"
                class="copy weui-swiped-btn weui-btn_primary"
                :data-clipboard-text="installcmd"
                @click="toClipboard"
                >{{ $t("copy") }}</a
              >
            </div>
          </div>
          <div style="padding-top: 24px; padding-bottom: 24px">
            {{ $t("inst.linuxDescWrt") }}
          </div>
          <div class="weui-cell weui-cell_swiped">
            <div
              role="option"
              class="weui-cell__bd"
              style="transform: translateX(-68px)"
            >
              <div class="weui-cell">
                <textarea
                  v-model="installcmd2"
                  class="weui-textarea"
                  style="padding-left: 64px; min-height: 80px"
                />
              </div>
            </div>
            <div class="weui-cell__ft">
              <a
                role="button"
                class="copy weui-swiped-btn weui-btn_primary"
                :data-clipboard-text="installcmd2"
                @click="toClipboard"
                >{{ $t("copy") }}</a
              >
            </div>
          </div>
          <div style="padding-top: 24px; padding-bottom: 24px">
            {{ $t("inst.linuxDescDocker") }}
          </div>
          <div class="weui-cell weui-cell_swiped">
            <div
              role="option"
              class="weui-cell__bd"
              style="transform: translateX(-68px)"
            >
              <div class="weui-cell">
                <textarea
                  v-model="installcmdDocker"
                  class="weui-textarea"
                  style="padding-left: 64px; min-height: 80px"
                />
              </div>
            </div>
            <div class="weui-cell__ft">
              <a
                role="button"
                class="copy weui-swiped-btn weui-btn_primary"
                :data-clipboard-text="installcmdDocker"
                @click="toClipboard"
                >{{ $t("copy") }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="activePage=='android'" role="tabpanel" class="weui-tab__panel">
          <div style="padding-top: 24px; padding-bottom: 24px">
            {{ $t("inst.androidDesc") }}
          </div>
          <div
            class="weui-form__opr-area"
            style="padding-top: 32px; margin-bottom: 32px"
          >
            <a
              class="weui-btn weui-btn_primary"
              href="https://openp2p.cn/download/v1/latest/openp2p-latest.apk"
              >{{ $t("inst.download") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from "clipboard"
import weui from "weui.js"
export default {
  name: "install",
  components: {},
  setup() {},
  data() {
    return {
      clients: [],
      profile: {},
      activePage: "windows",
      windowsActive: true,
      macActive: false,
      linuxActive: false,
      androidActive: false,
      windows64setup: "",
      windows32setup: "",
      installcmd: "",
      installcmd2: "",
    }
  },

  beforeMount() {},
  computed: {
    locale() {
      return this.$i18n.locale
    },
  },
  mounted() {
    this.loadClients()
    // alert(JSON.stringify(this.$store.state.token))
    this.windows64setup =
      "https://openp2p.cn/download/v1/latest/openp2p64-api.openp2p.cn-" +
      this.$store.state.token.installToken +
      "-setup.exe"
    this.windows32setup =
      "https://openp2p.cn/download/v1/latest/openp2p32-api.openp2p.cn-" +
      this.$store.state.token.installToken +
      "-setup.exe"
    this.installcmd =
      'sudo curl -k -o install.sh "https://openp2p.cn/download/v1/latest/install.sh" && sudo bash ./install.sh --token ' +
      this.$store.state.token.installToken
    this.installcmd2 =
      'wget --no-check-certificate -O install.sh "https://openp2p.cn/download/v1/latest/install.sh" && sh ./install.sh --token ' +
      this.$store.state.token.installToken
    this.installcmdDocker =
      "docker run -d --privileged --restart=always --net host --name openp2p-client -e OPENP2P_TOKEN=" +
      this.$store.state.token.installToken +
      " openp2pcn/openp2p-client:latest"
  },

  methods: {
    loadClients: async function () {},
    toClipboard: function () {
      let _this = this
      let clipboard = new ClipboardJS(".copy") // mobile mode will failed.
      let clipboard2 = new ClipboardJS(".copy") // mobile mode will failed.
      let clipboard3 = new ClipboardJS(".copy") // mobile mode will failed.
      clipboard.on("success", () => {
        weui.toast(_this.$t("copyOK"), 1000)
        clipboard.destroy()
        clipboard2.destroy()
        clipboard3.destroy()
      })
      clipboard.on("error", () => {
        weui.toast(_this.$t("copyError"), 1000)
        clipboard.destroy()
      })
    },
  },

  watch: {},
}
</script>


